import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { PLAYLIST_WRITE, hasPrivilege } from 'utils/privileges';
import FormStack from 'components/FormStack';
import { TitleCardWithToggle } from 'components/TitleCard';
import { AdditionalOptionsField, CustomDataField, OwnerField } from 'components/FormFields';
import { DefaultFormFieldLayout } from 'components/FormField';
function AdvancedSettingsCard(_ref) {
  var playlistForm = _ref.playlistForm,
    isDeleted = _ref.isDeleted,
    isDistributed = _ref.isDistributed;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fields = playlistForm.fields;
  var handleMemberContributions = function handleMemberContributions() {
    return fields.memberContributions.set(function (prevValue) {
      return !prevValue;
    });
  };
  var handleContentNumbering = function handleContentNumbering() {
    return fields.displayContentNumbers.set(function (prevValue) {
      return !prevValue;
    });
  };
  return /*#__PURE__*/React.createElement(TitleCardWithToggle, {
    variant: "raised",
    title: t('menu_advanced_settings')
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(OwnerField, {
    value: fields.owner.value,
    onChange: function onChange(owner) {
      return fields.owner.set(owner);
    },
    isDeleted: isDeleted,
    isDistributed: isDistributed
  }), config.enableContentExternalReference && hasPrivilege(PLAYLIST_WRITE) && /*#__PURE__*/React.createElement(CustomDataField, {
    customData: fields.externalRefId.value || '',
    onChange: function onChange(e) {
      var _fields$externalRefId;
      return (_fields$externalRefId = fields.externalRefId) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.set(e.target.value);
    },
    isDisabled: isDeleted
  }), /*#__PURE__*/React.createElement(AdditionalOptionsField, {
    isMemberContributionsEnabled: fields.memberContributions.value,
    onChangeMemberContributions: handleMemberContributions,
    isNumberingEnabled: fields.displayContentNumbers.value,
    onChangeNumbering: handleContentNumbering,
    isDistributed: isDistributed,
    isDeleted: isDeleted
  }))));
}
export default AdvancedSettingsCard;